import { ComponentProps } from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { NEW_SERVICE_FIELD, SERVICE_TYPE } from 'app/developer-v3/constants';
import { createNewService } from 'app/developer-v3/store/build/actions';
import { notify } from 'app/developer-v3/store/shared/actions';
import { saveServiceUpdates } from 'app/developer-v3/Actions';
import {
  selectCurrentService,
  selectIsAppVersionSaving,
} from 'app/developer-v3/store/build/selectors';

import TriggerSettings from './TriggerSettings';

const mapStateToProps = (state, props) => {
  const { params } = props;
  const isTriggerNew = params.triggerKey === NEW_SERVICE_FIELD;

  const trigger = selectCurrentService(state);
  const hasPerform =
    !!trigger?.operation?.perform?.url && !!trigger?.operation?.perform?.source;

  return {
    hasPerform,
    initialSettings: {
      description: trigger?.display?.description ?? '',
      directions: trigger?.display?.directions ?? '',
      hidden: trigger?.display?.hidden ?? false,
      key: trigger?.key ?? '',
      label: trigger?.display?.label ?? '',
      noun: trigger?.noun ?? '',
    },
    isSaving: selectIsAppVersionSaving(state),
    isTriggerFound: !isEmpty(trigger),
    isTriggerNew,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  async onSubmit(
    settingsNext: ComponentProps<typeof TriggerSettings>['initialSettings']
  ) {
    if (NEW_SERVICE_FIELD === ownProps.params.triggerKey) {
      return dispatch(
        createNewService(SERVICE_TYPE.triggers, {
          display: {
            description: settingsNext.description,
            // The backend doesn't like an empty string for directions.
            directions: settingsNext.directions || undefined,
            hidden: settingsNext.hidden,
            label: settingsNext.label,
          },
          key: settingsNext.key,
          noun: settingsNext.noun,
        })
      );
    }

    const isSuccess = await dispatch((_dispatch, getState) => {
      const state = getState(dispatch);
      const trigger = selectCurrentService(state);
      return dispatch(
        saveServiceUpdates(SERVICE_TYPE.triggers, {
          ...trigger,
          display: {
            description: settingsNext.description,
            directions: settingsNext.directions || undefined,
            hidden: settingsNext.hidden,
            label: settingsNext.label,
          },
          key: settingsNext.key,
          noun: settingsNext.noun,
        })
      );
    });

    if (isSuccess) {
      dispatch(
        notify.success(`Trigger: ${settingsNext.key} has been updated!`)
      );
    }

    return undefined;
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TriggerSettings);
